import React, { useEffect, useState } from 'react';
import { Box, Container, Typography, CircularProgress, Alert } from '@mui/joy';
import { useParams, useNavigate } from 'react-router-dom';
import { updateApplicantPublic } from '../../apiconfig/api';

const ConfirmActive: React.FC = () => {
  const { applicant_id } = useParams();
  const navigate = useNavigate();
  
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const handleConfirmActive = async () => {
      if (!applicant_id) {
        setError("Missing person ID");
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(null);
        
        // Update person to set isActive = true and lastActiveAt = now
        await updateApplicantPublic(applicant_id, {
          isActive: true,
          lastActiveAt: new Date().toISOString()
        });
        
        // Redirect to /apply after a short delay
        setTimeout(() => {
          navigate('/apply');
        }, 1500);
      } catch (err: any) {
        console.error("Error confirming active status:", err);
        setError(err.message || "Failed to confirm active status. Please try again.");
        setLoading(false);
      }
    };

    handleConfirmActive();
  }, [applicant_id, navigate]);

  if (error) {
    return (
      <Box sx={{ 
        minHeight: '100vh', 
        bgcolor: '#f4f4f4',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        py: 4
      }}>
        <Container maxWidth="sm">
          <Box sx={{ 
            bgcolor: 'white', 
            borderRadius: '16px', 
            p: 4, 
            textAlign: 'center',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)'
          }}>
            <Alert color="danger" sx={{ mb: 3 }}>
              {error}
            </Alert>
            <Typography level="h4" sx={{ fontWeight: 600, color: '#1A1B1D', mb: 2 }}>
              Unable to Confirm Active Status
            </Typography>
            <Typography level="body-md" sx={{ color: '#7B7F85', mb: 3 }}>
              We encountered an issue while confirming your active status. Please try again or contact support if the problem persists.
            </Typography>
          </Box>
        </Container>
      </Box>
    );
  }

  return (
    <Box sx={{ 
      minHeight: '100vh', 
      bgcolor: '#f4f4f4',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <Container maxWidth="sm">
        <Box sx={{ 
          bgcolor: 'white', 
          borderRadius: '16px', 
          p: 4, 
          textAlign: 'center',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)'
        }}>
          <CircularProgress size="lg" sx={{ mb: 2 }} />
          <Typography level="h4" sx={{ fontWeight: 600, color: '#1A1B1D' }}>
            Confirming your active status...
          </Typography>
          <Typography level="body-md" sx={{ color: '#7B7F85', mt: 1 }}>
            You'll be redirected shortly.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default ConfirmActive;

